import React, {Component} from "react"
import {Route, Switch} from "react-router-dom"
import {get} from "lodash"

import {NestedRoute, withPartialRoute} from "@irati/utils/history/routing"
import AppContainer from "@irati/ui/src/AppContainer"
import mainTheme from "@irati/ui/src/global/theme"
import {injectIntl, InjectIntl, LangLoader} from "@irati/utils/lang"
import {Payment} from "@irati/types"
import Deals from "@irati-web/perks/src/containers/Deals"
import DealInfo from "@irati-web/perks/src/containers/DealInfo"
import {PERKS, RECOGNITION} from "@irati-web/app/src/routeConfig"

import UserWalletContainer from "../containers/Wallet"
import RewardWalletContainer from "../containers/Reward/Reward"
import SendCreditContainer from "../containers/SendCredit"
import AdminRewardWalletContainer from "../containers/AdminReward/AdminRewardWallet"
import AdminRewardTopUpContainer from "../containers/AdminReward/AdminRewardTopUp"
import DistributeRewardContainer from "../containers/AdminReward/DistributeReward"
import {WalletRoutes, RawWalletRoutes} from "../enums/Routes"
import BudgetDashboard from "../containers/BudgetDashboard"
import {MarkdownStyles} from "../containers/styled/MarkdownStyles"
import AdminRewardTopUpSuccessContainer from "../containers/AdminReward/AdminRewardTopUpSuccessContainer"
import {PointsConversionMaintenance} from "../containers/PointsConversion"

interface Location {
  payment: Payment
}

interface Props extends InjectIntl {
  path: string
  location: Location
}

class Routes extends Component<Props> {
  render() {
    const {path, intl, formatMessage} = this.props
    const isI18nLoaded = !!get(intl.messages, "wallet.routes.wallet", null)
    const isCreditTopup = location.pathname.endsWith("/tenant/top-up")

    return (
      <Route
        path={path}
        render={() => (
          <LangLoader buckets={[PERKS, RECOGNITION]}>
            <MarkdownStyles />
            <AppContainer mainBackground={isCreditTopup && mainTheme.colors.primary2}>
              <Switch>
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}${WalletRoutes.REWARD_WALLET}`}
                  permissions="wallet.rewardWallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.rewardWallet"}) : ""}
                  component={RewardWalletContainer}
                />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}${WalletRoutes.FLEXI_BUDGET}`}
                  permissions="wallet.flexiRewards.budget"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={BudgetDashboard}
                />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}${WalletRoutes.SEND_CREDIT}`} // User GBP to User GBP
                  permissions="wallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.sendCredit"}) : ""}
                  component={SendCreditContainer}
                />
                <NestedRoute
                  match={path}
                  path={`${path}${WalletRoutes.FLEXI_CHECKOUT}`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={AdminRewardTopUpContainer}
                />
                <NestedRoute
                  match={path}
                  path={`${path}${WalletRoutes.FLEXI_CHECKOUT_COMPLETE}/:topUpId`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={AdminRewardTopUpSuccessContainer}
                />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}${WalletRoutes.FLEXI_REWARD}`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={AdminRewardWalletContainer}
                />
                <NestedRoute
                  match={path}
                  path={`${path}${WalletRoutes.FLEXI_ASSIGN}`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={DistributeRewardContainer}
                />
                <NestedRoute
                  match={path}
                  exact
                  useGrid={false}
                  path={`${path}${RawWalletRoutes.FLEXI_REWARD_CATEGORY}`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={Deals}
                />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}${RawWalletRoutes.FLEXI_REWARD_INFO}`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={DealInfo}
                />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}${WalletRoutes.POINTS_CONVERSION}`}
                  permissions="wallet"
                  title={"Maintenance"}
                  component={PointsConversionMaintenance}
                />
                <NestedRoute
                  match={path}
                  permissions="wallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={UserWalletContainer}
                />
              </Switch>
            </AppContainer>
          </LangLoader>
        )}
      />
    )
  }
}

export default withPartialRoute(injectIntl(Routes))
